import { APP_MARKET_PLACE } from 'constants/colors'

import { createTypeFromEnumValues } from 'utils/typescript'

import i18n from 'translations'

export enum APP_MARKETPLACE_STATUS {
  CONNECTED = 'connected',
  NOT_CONNECTED = 'not_connected'
}

export const APP_MARKETPLACE_STATUS_LABEL = {
  [APP_MARKETPLACE_STATUS.CONNECTED]: i18n.t('module:AppMarketplace:Status:connected'),
  [APP_MARKETPLACE_STATUS.NOT_CONNECTED]: i18n.t('module:AppMarketplace:Status:notConnected'),
}

export interface MarketPlaceDetailProps {
  detailImage?: string
  externalLink?: string
  integrationText?: string
  keyFeatures?: string[]
  learnMoreLink?: string
  specialOfferDetailText?: string
  subTitleImage?: string
}

export interface MarketPlaceProps {
  appLogo: string
  appName: string
  appType: 'be-paid' | 'external_app'
  description: string
  detail?: MarketPlaceDetailProps
  isStatusLoading?: boolean
  specialOfferText?: string
  status?: createTypeFromEnumValues<APP_MARKETPLACE_STATUS> | null
  title?: string
  titleColor?: string
  to?: string
}

export const BE_PAID_MARKET_PLACE: MarketPlaceProps = {
  appLogo: '/images/market-place/be-paid-logo.svg',
  appName: i18n.t('module:AppMarketplace:BePaid:appName'),
  appType: 'be-paid',
  description: i18n.t('module:AppMarketplace:BePaid:description'),
  detail: {
    detailImage: '/images/market-place/be-paid-detail.png',
    integrationText: i18n.t('module:AppMarketplace:BePaid:integrationText'),
    keyFeatures: [
      i18n.t('module:AppMarketplace:BePaid:keyFeature1'),
      i18n.t('module:AppMarketplace:BePaid:keyFeature2'),
      i18n.t('module:AppMarketplace:BePaid:keyFeature3'),
      i18n.t('module:AppMarketplace:BePaid:keyFeature4'),
    ],
    learnMoreLink: 'https://blossomeducational.com/features/mobile-payment/',
    specialOfferDetailText: i18n.t('module:AppMarketplace:BePaid:specialOfferDetailText'),
    subTitleImage: '/images/market-place/payment-gateway.svg',
  },
  specialOfferText: i18n.t('module:AppMarketplace:BePaid:specialOfferText'),
  status: 'connected',
  title: i18n.t('module:AppMarketplace:BePaid:title'),
  titleColor: APP_MARKET_PLACE.BE_PAID,
}

export const NOODLE_NOW_MARKET_PLACE: MarketPlaceProps = {
  appLogo: '/images/market-place/noodle-now-logo.svg',
  appName: i18n.t('module:AppMarketplace:NoodleNow:appName'),
  appType: 'external_app',
  description: i18n.t('module:AppMarketplace:NoodleNow:description'),
  detail: {
    detailImage: '/images/market-place/noodle-now-detail.png',
    externalLink: 'https://elearning.noodlenow.co.uk/index.php',
    keyFeatures: [
      i18n.t('module:AppMarketplace:NoodleNow:keyFeature1'),
      i18n.t('module:AppMarketplace:NoodleNow:keyFeature2'),
      i18n.t('module:AppMarketplace:NoodleNow:keyFeature3'),
      i18n.t('module:AppMarketplace:NoodleNow:keyFeature4'),
      i18n.t('module:AppMarketplace:NoodleNow:keyFeature5'),
    ],
    learnMoreLink: 'https://blossomeducational.com/noodlenow/',
    specialOfferDetailText: i18n.t('module:AppMarketplace:NoodleNow:specialOfferDetailText'),
    subTitleImage: '/images/market-place/staff-training.svg',
  },
  specialOfferText: i18n.t('module:AppMarketplace:NoodleNow:specialOfferText'),
  title: i18n.t('module:AppMarketplace:NoodleNow:title'),
  titleColor: APP_MARKET_PLACE.NOODLE_NOW,
}

export const BE_INSPIRED_MARKET_PLACE: MarketPlaceProps = {
  appLogo: '/images/market-place/be-inspired-logo.svg',
  appName: i18n.t('module:AppMarketplace:BeInspired:appName'),
  appType: 'external_app',
  description: i18n.t('module:AppMarketplace:BeInspired:description'),
  detail: {
    detailImage: '/images/market-place/be-inspired-detail.png',
    externalLink: 'https://online.blossombeinspired.co.uk/login',
    keyFeatures: [
      i18n.t('module:AppMarketplace:BeInspired:keyFeature1'),
      i18n.t('module:AppMarketplace:BeInspired:keyFeature2'),
      i18n.t('module:AppMarketplace:BeInspired:keyFeature3'),
      i18n.t('module:AppMarketplace:BeInspired:keyFeature4'),
    ],
    learnMoreLink: 'https://blossomeducational.com/features/beinspired/',
    specialOfferDetailText: i18n.t('module:AppMarketplace:BeInspired:specialOfferDetailText'),
    subTitleImage: '/images/market-place/activity-library.svg',
  },
  specialOfferText: i18n.t('module:AppMarketplace:BeInspired:specialOfferText'),
  title: i18n.t('module:AppMarketplace:BeInspired:title'),
  titleColor: APP_MARKET_PLACE.BE_INSPIRED,
}

export const BE_SEEN_MARKET_PLACE: MarketPlaceProps = {
  appLogo: '/images/market-place/be-seen-logo.svg',
  appName: i18n.t('module:AppMarketplace:BeSeen:appName'),
  appType: 'external_app',
  description: i18n.t('module:AppMarketplace:BeSeen:description'),
  detail: {
    detailImage: '/images/market-place/be-seen-detail.png',
    keyFeatures: [
      i18n.t('module:AppMarketplace:BeSeen:keyFeature1'),
      i18n.t('module:AppMarketplace:BeSeen:keyFeature2'),
      i18n.t('module:AppMarketplace:BeSeen:keyFeature3'),
      i18n.t('module:AppMarketplace:BeSeen:keyFeature4'),
    ],
    learnMoreLink: 'https://blossomeducational.com/features/be-seen/',
    specialOfferDetailText: i18n.t('module:AppMarketplace:BeSeen:specialOfferDetailText'),
    subTitleImage: '/images/market-place/web-builder.svg',
  },
  specialOfferText: i18n.t('module:AppMarketplace:BeSeen:specialOfferText'),
  title: i18n.t('module:AppMarketplace:BeSeen:title'),
  titleColor: APP_MARKET_PLACE.BE_SEEN,
}

export const ROUTE_PATH_MAPPING = {
  'be-inspired': BE_INSPIRED_MARKET_PLACE,
  'be-paid': BE_PAID_MARKET_PLACE,
  'be-seen': BE_SEEN_MARKET_PLACE,
  'noodle-now': NOODLE_NOW_MARKET_PLACE,
} as const
